import { AttachmentsScope, ImageDisplayStyle } from '../../types/model/common';
import { MessageSectionEstimateConfig } from '../buildReportPageEstimateInput';
import { ReportMessageEstimateEntry } from '../reportIssueEstimateRow';
import { documentSectionNodes, SECTION_HEADER_HEIGHT } from './documentSectionNodes';
import { estimatePlainTextHeight } from './measurePdfText';
import { CONTENT_WIDTH, FONT_SIZE } from './pdfLayoutConstants';
import { LayoutNode, leaf } from './pdfLayoutEngine';

const MESSAGE_TABLE_HEADER_HEIGHT = 18;
const MESSAGE_ENTRY_ROW_HEIGHT = 22;

function messageEntryNodes(
  entry: ReportMessageEstimateEntry,
  config: MessageSectionEstimateConfig
): LayoutNode[] {
  const nodes: LayoutNode[] = [];
  const contentHeight = estimatePlainTextHeight(
    'x'.repeat(entry.textChars),
    FONT_SIZE.content,
    CONTENT_WIDTH
  );
  nodes.push(leaf(MESSAGE_ENTRY_ROW_HEIGHT + contentHeight));

  if (config.attachmentsEnabled) {
    nodes.push(
      ...documentSectionNodes({
        counts: entry.documents,
        displayStyle: config.displayStyle,
        scope: AttachmentsScope.all,
        hasMainImage: false,
        includeSectionHeaders: false,
        flowContentAcrossPages: true,
      })
    );
  }
  return nodes;
}

export function messageSectionNodes(
  entries: ReportMessageEstimateEntry[],
  config: MessageSectionEstimateConfig
): LayoutNode[] {
  if (!config.enabled || entries.length === 0) {
    return [];
  }
  const nodes: LayoutNode[] = [
    leaf(SECTION_HEADER_HEIGHT),
    leaf(MESSAGE_TABLE_HEADER_HEIGHT),
  ];
  for (const entry of entries) {
    nodes.push(...messageEntryNodes(entry, config));
  }
  return nodes;
}
